import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';
import { z } from 'zod';
import { DeleteButton, EditButton } from '../../components/TableActionButtons';

export const getConstitutionsTableConfig = (handleEdit, handleDelete, tr) => [
    {
        header: () => (
            <span className="flex items-center">
               
                {tr('table.name')}
            </span>
        ),
        accessorKey: 'name',
        cell: ({ row }) => (
            <div className="flex flex-col justify-start items-start truncate">
                <div className="text-left flex items-center">
                    <span className="font-medium">{row.original.name}</span>
                </div>
            </div>
        )
    },
    {
        header: () => (
            <span className="flex items-center">
                {tr('table.weight')}
            </span>
        ),
        accessorKey: 'weight',
        cell: ({ row }) => (
            <div className="flex flex-col justify-start items-start truncate">
                <div className="text-left flex items-center">
                    <span className="font-medium">{row.original.weight}</span>
                </div>
            </div>
        )
    },
    {
        header: () => (
            <span className="flex items-center">
                
                {tr('table.description')}
            </span>
        ),
        accessorKey: 'description',
        cell: ({ row }) => (
            <div className="flex flex-col justify-start items-start truncate">
                <div className="text-left flex items-center">
                    <span className="font-medium">{row.original.description}</span>
                </div>
            </div>
        )
    },
    {
        header: () => (
            <span className="flex items-center justify-center">
                <FontAwesomeIcon icon={faEllipsis} className="w-4 h-4 mr-2" />
                {tr('table.actions')}
            </span>
        ),
        id: 'actions',
        cell: ({ row }) => (
            <div className="flex items-center justify-center gap-3">
                <EditButton onClick={() => handleEdit(row.original)} row={row} />
                <DeleteButton onClick={handleDelete} row={row} />
            </div>
        )
    }
];

export const PAGE_CONFIG = {
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Roles', link: '/roles' }
    ],
    PAGE_TITLE: 'Roles',
    GET_QUERY_KEY: 'roles',
    API_CALL: () => api.roles.getRoles(),
    DEFAULT_ERROR_MESSAGE: 'Failed to fetch roles',
    SELECT: (data) => data?.data,
    //Delete
    DELETE_API_CALL: (id) => api.roles.deleteRole(id),
    DELETE_ERROR_MESSAGE: 'Failed to delete role',
    DELETE_SUCCESS_MESSAGE: 'Role deleted successfully',
    //Create
    CREATE_API_CALL: (data) => api.roles.createRole(data),
    CREATE_ERROR_MESSAGE: 'Failed to create role',
    CREATE_SUCCESS_MESSAGE: 'Role created successfully',
    // Update
    UPDATE_API_CALL: (data) => api.roles.updateRole(data),
    UPDATE_ERROR_MESSAGE: 'Failed to update role',
    UPDATE_SUCCESS_MESSAGE: 'Role updated successfully'
};

export const INITIAL_FORM_STATE = {
    name: ''
};

export const INITIAL_ERROR_STATE = {
    name: ''
};

export const getFormConfig = (formData, handleInputChange, errors) => [
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Role',
        id: 'name',
        placeholder: 'Enter Role',
        name: 'name',
        type: 'text',
        // required: true,
        value: formData.name,
        onChange: (e) => handleInputChange('name', e.target.value),
        error: errors.name
    },
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Weight',
        id: 'weight',
        placeholder: 'Enter Weight',
        name: 'weight',
        type: 'number',
        min: 1,
        value: formData.weight,
        onChange: (e) => handleInputChange('weight', Number(e.target.value) || ''),
        error: errors.weight
    },
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Description',
        id: 'description',
        placeholder: 'Enter Description',
        name: 'description',
        type: 'text',
        // required: true,
        value: formData.description,
        onChange: (e) => handleInputChange('description', e.target.value),
        error: errors.description
    }
];
export const CONSTITUTION_SCHEMA = z.object({
    name: z.string().min(3, 'Role must be at least 3 characters'),
    weight: z.number().min(1, 'Weight must be at least 1'),
    description: z.string().min(3, 'Role description must be at least 3 characters')
});
